import * as React from "react";
import {
  ActiveCell,
  AllowedDocumentCell,
  AllowedTypeCell,
  SignatureCell,
} from "../GridComponents";
import EditActivity from "./EditActivity";
import List from "components/Setting/List";
import {
  updateActivityType,
  useActivityType,
} from "services/activityTypeService";

const BackgroundColorCell = (props) => {
  const { dataItem } = props;
  let backgroundColor = undefined;

  if (dataItem.rowStyle) {
    if (typeof dataItem.rowStyle === "string") {
      const match = dataItem.rowStyle.match(/backgroundColor:['"]([^'"]+)['"]/);
      if (match && match[1]) {
        backgroundColor = match[1];
      }
    }
  }

  return (
    <td className="text-center align-middle">
      {backgroundColor ? (
        <div
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: backgroundColor,
            border: "1px solid #ccc",
            borderRadius: "3px",
            margin: "0 auto",
          }}
        />
      ) : (
        <div
          style={{
            width: "18px",
            height: "18px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "3px",
            position: "relative",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "22px",
              height: "2px",
              background: "#f8c2c2",
              transform: "translate(-50%, -50%) rotate(45deg)",
              borderRadius: "1px",
            }}
          />
        </div>
      )}
    </td>
  );
};

const ActivitiesList = () => {
  const { data: gridData, loading } = useActivityType();

  return (
    <List
      editAction={updateActivityType}
      editFormComponent={EditActivity}
      component="activityTypes"
      columns={[
        { field: "name", title: " ", cell: SignatureCell, width: "80" },
        { field: "code", title: "Code", width: "80" },
        { field: "name", title: "Name", width: "180" },
        {
          cell: AllowedTypeCell,
          title: "Time",
          field: "allowTime",
          width: "50",
        },
        {
          cell: AllowedDocumentCell,
          title: "Documents",
          field: "allowedDocument",
          width: "80",
          headerClassName: "text-center",
        },
        { cell: ActiveCell, title: "Active", field: "active", width: "55" },
        {
          cell: BackgroundColorCell,
          title: "Row Colour",
          field: "rowStyle",
          width: "80",
        },
      ]}
      gridData={gridData}
      loading={loading}
    />
  );
};

export default ActivitiesList;
